import { gql } from '@apollo/client';

export * from './integrationMembers.query.generated';

export const INTEGRATION_MEMBERS = gql`
  query integrationMembers($integrationId: ID!, $query: String) {
    integrationMembers(integrationId: $integrationId, query: $query) {
      id
      role
      user {
        id
        name
      }
    }
  }
`;
